import { render, staticRenderFns } from "./Renglonaje.vue?vue&type=template&id=4783050e&"
import script from "./Renglonaje.vue?vue&type=script&lang=js&"
export * from "./Renglonaje.vue?vue&type=script&lang=js&"
import style0 from "./Renglonaje.vue?vue&type=style&index=0&id=4783050e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports